import type { PreviewEnvironmentManager } from '../preview-environments/preview-environment-manager.js';
import type { LogFn } from '../log.js';
import type { CloseableBridgeState } from './close-bridge-connection.js';
import type { MainBridgeReconnectState } from './reconnect/index.js';
import type { BridgeIdentifiedPayload } from './bridge-identified-types.js';
import { attachFirehoseAfterIdentified } from './attach-firehose-after-identified.js';

export type { BridgeIdentifiedPayload } from './bridge-identified-types.js';

export function createOnBridgeIdentified(opts: {
  previewEnvironmentManager: PreviewEnvironmentManager;
  firehoseServerUrl: string | undefined;
  workspaceId: string;
  state: MainBridgeReconnectState & CloseableBridgeState;
  logFn: LogFn;
}): (msg: BridgeIdentifiedPayload) => void {
  const { previewEnvironmentManager, firehoseServerUrl, workspaceId, state, logFn } = opts;

  const firehoseCtx = { state, previewEnvironmentManager, logFn };

  return (msg: BridgeIdentifiedPayload) => {
    const bridgeName = msg.bridgeName;
    const proxyPorts = Array.isArray(msg.proxyPorts) ? msg.proxyPorts : [];
    const previewEnvironments = msg.previewEnvironments ?? [];
    setImmediate(() => {
      previewEnvironmentManager.applyConfig(previewEnvironments);
      if (!firehoseServerUrl || typeof bridgeName !== 'string' || !bridgeName) return;
      state.firehoseReconnectAttempt = 0;
      attachFirehoseAfterIdentified(firehoseCtx, {
        firehoseServerUrl,
        workspaceId,
        bridgeName,
        proxyPorts,
      });
    });
  };
}
